import React from "react";
import {
  clearAgentAction,
  showErrorMessage,
  showSuccessMessage,
} from "../../../../actions";
import { useDispatch } from "react-redux";
import { resolveErrorMessage } from "../../../../util";
import ActionDialog from "../../ActionDialog";
import { Typography } from "@material-ui/core";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import LoadingSpinner from "../../LoadingSpinner";

const RemoveAgentDialog = ({ open, onClose, user, onComplete }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);

  const clearAgent = async () => {
    setLoading(true);
    try {
      await clearAgentAction({ editedUserId: user.id });
      dispatch(showSuccessMessage("app.user.hasBeenRemovedFromYourDataBase"));
      await onComplete();
    } catch (e) {
      const errorMessage = resolveErrorMessage(e);
      dispatch(showErrorMessage(errorMessage));
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <ActionDialog
      title="app.confirmations"
      open={open}
      onAccept={clearAgent}
      onClose={onClose}
      textConfirm="app.ok"
      disableConfirmButton={loading}
    >
      {loading ? (
        <LoadingSpinner
          message={<FormattedMessage id="app.loading.updating" />}
        />
      ) : (
        <>
          <Typography variant="body1">
            <FormattedHTMLMessage id="app.agentOrAgentManager.clear.text" />
          </Typography>
        </>
      )}
    </ActionDialog>
  );
};

export default React.memo(RemoveAgentDialog);
